import DashboardIcon from "@material-ui/icons/Dashboard";
import ShoppingCartIcon from "@material-ui/icons/ShoppingCart";
import { AiFillEdit, AiFillTags } from "react-icons/ai";
import { GiTatteredBanner } from "react-icons/gi";
import { IoMdPhotos, IoMdVideocam } from "react-icons/io";
import { HiMail } from "react-icons/hi";
import { MdChevronRight, MdGrade } from "react-icons/md";
import { NavItem } from "./LinkItem";
import React from "react";
import { CgNametag } from "react-icons/cg";

export const menus: NavItem[] = [
  // {
  //   children: undefined,
  //   navTo: "/",
  //   title: "Начало",
  //   icon: <DashboardIcon />,
  // },
  {
    children: undefined,
    navTo: "/orders",
    title: "Поръчки",
    icon: <ShoppingCartIcon />,
  },
  {
    navTo: "",
    title: "Артикули",
    icon: <AiFillEdit size="1.5rem" />,
    children: [
      {
        children: undefined,
        navTo: "/products",
        title: "Климатици",
        icon: <MdChevronRight size="1.5rem" />,
      },
      {
        children: undefined,
        navTo: "/accessories",
        title: "Аксесоари",
        icon: <MdChevronRight size="1.5rem" />,
      },
      {
        children: undefined,
        navTo: "/installations",
        title: "Цени за монтажи",
        icon: <MdChevronRight size="1.5rem" />,
      },
      {
        children: undefined,
        navTo: "/tags",
        title: "Тагове",
        icon: <MdChevronRight size="1.5rem" />,
      },
    ],
  },
  {
    children: undefined,
    navTo: "/metas",
    title: "Мета",
    icon: <CgNametag size="1.5rem" />,
  },
  {
    children: undefined,
    navTo: "/banners",
    title: "Банери",
    icon: <GiTatteredBanner size="1.5rem" />,
  },
  {
    children: undefined,
    navTo: "/gallery",
    title: "Галерия",
    icon: <IoMdPhotos size="1.5rem" />,
  },
  {
    children: undefined,
    navTo: "/videos",
    title: "Видеа",
    icon: <IoMdVideocam size="1.5rem" />,
  },
  {
    children: undefined,
    navTo: "/comments",
    title: "Ревю",
    icon: <AiFillTags size="1.5rem" />,
  },
  {
    children: undefined,
    navTo: "/email-sender",
    title: "Пощальон",
    icon: <HiMail size="1.5rem" />,
  },
  {
    children: undefined,
    navTo: "/promotions",
    title: "Промоции",
    icon: <MdGrade size="1.5rem" />,
  },
];
